import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, FormLabel, FormElement } from "../../../components/StyledElements";
import { useLiveEvents } from "../../../contexts/LiveEventsContext";
import { useSelector } from "react-redux";
import { dateTimeFormatter, getLocalDateFromString } from "../../../utils/utils";
import { getLiveEventRecordings } from "../../../services/liveevents";
import { Icon } from "@iconify/react";

export const MediaDocs = ({ style = {}, onSelectTab = () => { } }) => {
  const [updatedImage, setUpdatedImage] = useState(null);
  const [updatedVideo, setUpdatedVideo] = useState(null);
  const [liveEventRecordings, setLiveEventRecordings] = useState([]);
  const { selectedEvent, updatedEvent, setUpdatedEvent } = useLiveEvents();

  const activeUser = useSelector((state) => state.users.activeUser);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchRecordings = async () => {
      const results = await getLiveEventRecordings(selectedEvent.public_id);
      if (results.success) {
        console.log("!!! LIVE EVENT RECORDINGS: ", results.recordings);
        setLiveEventRecordings(results.recordings);
      } else {
        setLiveEventRecordings([]);
      }

    }

    if (selectedEvent?.public_id) {
      fetchRecordings();
    } else {
      setLiveEventRecordings([]);
    }

  }, [selectedEvent]);

  useEffect(() => {
    console.log("!!! UPDATED VIDEO CHANGED: ", updatedVideo);
  }, [updatedVideo]);

  useEffect(() => {
    // Reset updated image when updatedEvent changes
    console.log("!!! UPDATED EVENT CHANGED: ", updatedEvent);
    setUpdatedImage(updatedEvent?.image_data || null);
  }, [updatedEvent]);

  useEffect(() => {
    setUpdatedEvent({
      ...updatedEvent,
      image_data: updatedImage,
    });
  }, [updatedImage]);

  return (
    <div style={{ display: "flex", flexDirection: "column", ...style }}>
      <FormElement>
        <FormLabel label="Event Thumbnail" />
        <div style={{ display: "flex", flexDirection: "row", gap: "10px", marginBottom: "10px", height: "auto", position: "relative" }}>
          {
            updatedImage || updatedEvent?.image_url ? (
              <img src={updatedImage || updatedEvent.image_url} alt="Primary Media" style={{ width: "50%", height: "auto", borderRadius: "8px", position: "relative" }} />
            ) : null
          }
          <div style={{
            width: "50%",
            border: "2px dashed #ccc",
            position: "relative",
            flexGrow: 1,
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#999",
            fontStyle: "italic",
            minHeight: "200px",
          }}
          >
            Drag & Drop Image Here
            <input type="file" style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              top: 0,
              left: 0,
              opacity: 0,
              cursor: "pointer",
            }}
              onChange={(e) => {
                // Handle file selection logic here
                const file = e.target.files[0];
                console.log("Selected file: ", file);
                if (file) {
                  if (!file.type.startsWith("image/")) {
                    alert("Please upload a valid image file.");
                    return;
                  }

                  const reader = new FileReader();
                  reader.onloadend = () => {
                    console.log("!!! READER RESULT: ", reader.result);
                    setUpdatedImage(reader.result);
                  };
                  reader.readAsDataURL(file);


                  setUpdatedEvent({
                    ...updatedEvent,
                    image_file_name: file.name,
                  });
                }
              }}
            />
          </div>
        </div>
      </FormElement>
      <FormElement>
        <FormLabel label="Event Video" />
        <div style={{ display: "flex", flexDirection: "row", gap: "10px", marginBottom: "10px", height: "auto", position: "relative" }}>
          {
            updatedVideo || updatedEvent?.video_url ? (
              <video controls style={{ borderRadius: "8px" }} src={updatedVideo || updatedEvent.video_url} style={{ width: "50%", height: "100%", minHeight: "100%", aspectRatio: 16 / 9 }} type="video/mp4" preload="metadata" >
                Your browser does not support the video tag.
              </video>
            ) : null
          }
          <div style={{
            width: "50%",
            border: "2px dashed #ccc",
            position: "relative",
            flexGrow: 1,
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#999",
            fontStyle: "italic",
            minHeight: "200px",
          }}
          >
            Drag & Drop Video Here
          <input type="file" style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              top: 0,
              left: 0,
              opacity: 0,
              cursor: "pointer",
            }}
              onChange={(e) => {
                // Handle file selection logic here
                const file = e.target.files[0];
                console.log("Selected video file: ", file);
                if (file) {
                  if (!file.type.startsWith("video/")) {
                    alert("Please upload a valid video file.");
                    return;
                  }

                  setUpdatedVideo(prev => {
                    if (prev) URL.revokeObjectURL(prev);
                    return URL.createObjectURL(file);
                  });

                  //setUpdatedVideo(file);

                  /* Show the video, even if it's large - we can handle the upload separately */
                  /*
                  const reader = new FileReader();
                  reader.onloadend = () => {
                    setUpdatedVideo(reader.result);
                  };
                  reader.readAsDataURL(file);
                  */

                  console.log("!!! FILE: ", file);

                  setUpdatedEvent({
                    ...updatedEvent,
                    video_file: file,
                    video_file_name: file.name,
                  });
                };
              }}
            />
          </div>
        </div>
      </FormElement>
      <FormElement>
        <div style={{ display: "flex", flexDirection: "row", gap: "10px", justifyContent: "space-between", alignItems: "center" }}>
          <FormLabel label="Recordings" />
          <Button
            title={!updatedEvent?.public_id ? "Save the event to enable recording" : "Start a new recording for this live event"}
            disabled={!updatedEvent?.public_id}
            onClick={() => {
              if (!updatedEvent?.public_id) {
                return;
              }

              // Logic to start/stop recording
              //
              if (activeUser?.user_type.match(/client/)) {
                navigate(`/client/live-event/record/${selectedEvent.public_id}`);
              } else {
                navigate(`/live-event/record/${selectedEvent.public_id}`);
              }
            }}>
            { /* Change button text based on recording state */}
          + New Recording
        </Button>
        </div>
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            flexWrap: "wrap",
          }}
        >{
            liveEventRecordings.length > 0 ? (
              liveEventRecordings
                .sort((a, b) => new Date(a.started_at).getTime() < new Date(b.started_at).getTime() ? 1 : -1)
                .map((recording) => {
                  const url = recording.path ? recording.path.replace("/out", "https://webrtc.agentwire.ai/recordings") : recording.playlist_name.replace("/out", "https://webrtc.agentwire.ai/recordings");
                  const videoSelected = (updatedEvent.video_url === url) || (updatedVideo === url);
                  return (<div key={recording.public_id} style={{ padding: "10px", borderBottom: "1px solid #eee", width: "50%" }} >
                    <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center", justifyContent: "space-between" }}>
                      <div style={{ fontWeight: "600" }}>{recording.title || `Recording - ${new Date(recording.created_at).toLocaleString()}`}</div>
                      <div
                        style={{
                          textDecoration: "underline",
                          cursor: "pointer",
                          border: videoSelected ? "2px solid green" : "2px solid #ccc",
                          backgroundColor: videoSelected ? "rgba(0, 255, 0, 0.1)" : "transparent",
                          borderRadius: "50%",
                          width: "30px",
                          height: "30px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}

                        onClick={() => {
                          const newUpdatedEvent = { ...updatedEvent };
                          newUpdatedEvent.video_url = url;
                          setUpdatedEvent(newUpdatedEvent);
                          setUpdatedVideo(url);
                        }}

                      >
                        <Icon icon="fa-solid:check" style={{ color: videoSelected ? "green" : "#ccc", height: "20px", width: "20px" }} />

                      </div>
                    </div>
                    <div style={{ fontStyle: "italic" }}>{dateTimeFormatter.format(getLocalDateFromString(recording.started_at))}</div>
                    <video width="100%" height="auto" preload="metadata" controls style={{ borderRadius: "8px", marginTop: "10px" }} src={recording.path ? recording.path.replace("/out", "https://webrtc.agentwire.ai/recordings") : recording.playlist_name.replace("/out", "https://webrtc.agentwire.ai/recordings")} type="video/mp4" >
                      Your browser does not support the video tag.
                </video>
                  </div>);
                })
            ) : (
              <div style={{ color: "#999", fontStyle: "italic", marginTop: "10px" }}>No recordings yet.</div>
            )
          }
        </div>
      </FormElement>
      <div
        style={{
          marginTop: "20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px"
        }}
      >
        <Button
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "auto",
            padding: "0px 16px"
          }}

          onClick={() => {
            onSelectTab("agent-settings");
          }}
        >+ Agent Settings</Button>
      </div>
    </div >
  );
};

export default MediaDocs;
